export default {
  home: 'こんにちは',
  switchLang: 'English',
};
